/* tslint:disable:react-a11y-anchors */
import * as React from 'react'

import EnhancedLazyLoad from '../../../components/enhancedLazyLoad'
import AudioPlayerSmallContainer from '../audio/audioPlayerSmallContainer'
import ImagePlaceholder from '../imagePlaceholder'
import TrendingSash from './common/trendingSash'

import * as styles from './gridAudio.module.css'

const AudioPreview = ({
  imageUrl,
  audioUrl,
  url,
  isTrending,
  name,
  onClick,
  rank,
  lazyLoad = false
}: {
  imageUrl: string | undefined
  audioUrl: string
  url: string
  isTrending: boolean
  name: string
  onClick?: () => void
  rank: number
  lazyLoad?: boolean
}) => {
  return (
    <div>
      <div className={styles.miniAudioPlayerContainer}>
        <AudioPlayerSmallContainer src={audioUrl} />
      </div>
      <a
        className={styles.thumbnail}
        href={`${url}?s_rank=${rank}`}
        onClick={onClick}
        aria-label={name}
      >
        {isTrending && <TrendingSash />}
        <EnhancedLazyLoad
          disabled={!lazyLoad}
          placeholder={<ImagePlaceholder />}
        >
          <img alt={name} src={imageUrl} title={name} width="80" height="80" />
        </EnhancedLazyLoad>
      </a>
    </div>
  )
}

export default AudioPreview
